import React from 'react';

import AiInvestigationContextItem from './AiInvestigationContextItem';
import JiraCloudContextItem from './JiraCloudContextItem';
import ServiceNowContextItem from './ServiceNowContextItem';

const rendererMap = {
  servicenow: ServiceNowContextItem,
  ai_investigation: AiInvestigationContextItem,
  jira_cloud: JiraCloudContextItem
};

export const getAiInvestigationContext = (contexts) => {
  if (!Array.isArray(contexts)) {
    return null;
  }

  const ctx = contexts.find((c) => c.ai_investigation);
  return ctx?.ai_investigation || null;
};

export const renderAiInvestigationItems = (contexts, props = {}) => {
  if (!Array.isArray(contexts)) {
    return null;
  }

  const items = contexts
    .filter((c) => c.ai_investigation?.investigation_id)
    .map((context) => (
      <AiInvestigationContextItem key={context.ai_investigation.investigation_id} context={context} {...props} />
    ));

  return items.length > 0 ? items : null;
};

export const renderExternalContextItems = (contexts, props = {}) => {
  if (!Array.isArray(contexts) || contexts.length === 0) {
    return null;
  }

  const externalContexts = contexts.filter((c) => !c.ai_investigation);

  const items = externalContexts
    .map((context, idx) => {
      const key = Object.keys(context)[0];
      const Renderer = rendererMap[key];
      // eslint-disable-next-line react/no-array-index-key
      return Renderer ? <Renderer key={`${key}-${idx}`} context={context} {...props} /> : null;
    })
    .filter(Boolean);

  return items.length > 0 ? items : null;
};

export { rendererMap };
